import { createApp } from 'vue'
import { createPinia } from 'pinia' // 导入 Pinia
import App from './App.vue'
import router from './router'; // 导入路由配置
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


const pinia = createPinia()
createApp(App).use(router).use(pinia).use(ElementPlus).mount('#app')




